export class CreditCardRefundResponse {
  public constructor() {
    this.Succeeded = false;
    this.TransactionId = '';
    this.RawTransactionResult = '';
    this.CcId = '';
    this.PreviouslyVoidedOrRefunded = false;
  }

  public Succeeded: boolean;
  public TransactionId: string;
  public RawTransactionResult: string;
  public CcId: string;
  public PreviouslyVoidedOrRefunded: boolean;
}
